var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMindful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67056 35.2969V30.8556C7.67056 26.9747 6.73871 23.1528 4.96213 19.6931C4.07267 17.9517 3.5627 15.9808 3.53781 13.8948C3.46405 6.65353 9.2469 0.761202 16.4879 0.703545C23.7515 0.645959 29.658 6.51326 29.658 13.7598C29.658 14.9081 29.9366 16.0398 30.4773 17.0565L33.3238 21.6141C33.7381 22.3876 33.1832 23.3262 32.3045 23.3414L29.6609 23.3835V26.9011C29.6609 28.4131 28.4248 29.6489 26.9132 29.6489H23.1324V35.2969H7.67056Z",
    stroke: "#101418",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5943 14.3282C17.6711 14.3282 18.5441 12.0682 18.5441 9.2803C18.5441 6.49243 17.6711 4.23242 16.5943 4.23242C15.5175 4.23242 14.6445 6.49243 14.6445 9.2803C14.6445 12.0682 15.5175 14.3282 16.5943 14.3282Z",
    stroke: "#101418",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2832 12.3868C21.3713 12.3057 21.4578 12.2229 21.5426 12.1383C23.0681 10.6127 23.8443 8.72697 23.7332 7.19015C22.1964 7.07906 20.3107 7.85524 18.7851 9.38081C18.7005 9.46556 18.6177 9.55204 18.5366 9.64019C18.4658 11.3799 17.8843 12.9124 17.0137 13.9095C18.0107 13.0388 19.5436 12.4576 21.2832 12.3868Z",
    stroke: "#101418",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6416 16.2784C24.4295 16.2784 26.6895 15.4055 26.6895 14.3287C26.6895 13.2518 24.4295 12.3789 21.6416 12.3789C18.8538 12.3789 16.5938 13.2518 16.5938 14.3287C16.5938 15.4055 18.8538 16.2784 21.6416 16.2784Z",
    stroke: "#101418",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9058 12.3868C13.6454 12.4576 15.1783 13.0388 16.1754 13.9095C15.3047 12.9124 14.7232 11.3799 14.6524 9.64019C14.5714 9.55204 14.4885 9.46556 14.4039 9.38081C12.8783 7.85524 10.9926 7.07906 9.45578 7.19015C9.34469 8.72697 10.1209 10.6127 11.6464 12.1383C11.7312 12.2229 11.8177 12.3058 11.9058 12.3868Z",
    stroke: "#101418",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5459 16.2784C14.3338 16.2784 16.5938 15.4055 16.5938 14.3287C16.5938 13.2518 14.3338 12.3789 11.5459 12.3789C8.75806 12.3789 6.49805 13.2518 6.49805 14.3287C6.49805 15.4055 8.75806 16.2784 11.5459 16.2784Z",
    stroke: "#101418",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindful);
export default __webpack_public_path__ + "static/media/mindful.71013da8c146fda05a05632ecaac182f.svg";
export { ForwardRef as ReactComponent };